// extracted by mini-css-extract-plugin
export default {"label":"File_label__dfi1M","tooltip":"File_tooltip__Qw9RI","wrap":"File_wrap__bosL-","input":"File_input__2XGNV","box":"File_box__NJ7XU"};